(function(){
    document.body.addEventListener('change', function (event) {
        if (event.target.closest('.form-cart')) {
            var form = event.target.closest('.form-cart');
            var url = form.getAttribute('data-url');
            var cart_summary = form.querySelector('.cart-summary-totals');

            fetch(url, {
                method: 'post',
                body: new FormData(form)
            }).then(res=>res.json())
                .then(function (data) {
                    cart_summary.innerHTML = data.summary;

                    var tooltipTriggerList = cart_summary.querySelectorAll('[data-bs-toggle="tooltip"]');
                    var tooltipList = Array.prototype.slice.call(tooltipTriggerList).map(function (tooltipTriggerEl) {
                        return new bootstrap.Tooltip(tooltipTriggerEl);
                    });
                });
        }
    });

    document.body.addEventListener('keydown', function (event) {
        if (event.target.closest('.cart-coupon-code')) {
            var container = event.target.closest('.cart-coupon-code');
            container.classList.remove('error', 'success');
        }
    });

    document.body.addEventListener('keydown', function(event){
        if (event.target.closest('.cart-coupon-code')) {
            if (event.code === "Enter") {
                event.target.closest('.cart-coupon-code').querySelector('.btn').dispatchEvent(new Event('click', {bubbles: true}));
                event.preventDefault();
            }
        }
    });

    document.body.addEventListener('click', function(event){
        if (event.target.closest('.cart-coupon-code') && event.target.closest('.btn')) {
            var container = event.target.closest('.cart-coupon-code');
            var btn = event.target.closest('.btn');
            var input = container.querySelector('input');
            var code = input.value;

            container.classList.remove('error', 'success');

            if (!input.value.length) {
                input.focus();
                return false;
            }

            var url = container.getAttribute('data-url');
            fetch(url, {
                method: 'post',
                body: 'coupon_code='+code,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            }).then(res=>res.json())
                .then(function (data) {
                    if (data.valid) {
                        container.classList.add('success');
                    } else {
                        container.classList.add('error');
                    }
                }
            );
        }
    });

    document.body.addEventListener('click', function(event){
        if (event.target.closest('.cart-summary-spend') && event.target.closest('.btn-cancel')) {
            var container = event.target.closest('.cart-summary-spend');
            var input = container.querySelector('input');
            var input_real = container.querySelector('.spend_amount_accepted');

            container.classList.remove('error', 'success');
            input.removeAttribute('readonly', 'readonly');
            input_real.value = 0;
            input_real.dispatchEvent(new Event('change', {bubbles: true}));
        }
    });

    document.body.addEventListener('click', function(event){
        if (event.target.closest('.cart-summary-spend') && event.target.closest('.btn-accept')) {
            var container = event.target.closest('.cart-summary-spend');
            var input = container.querySelector('input[type="number"]');
            var input_real = container.querySelector('.spend_amount_accepted');
            var value = input.value;

            container.classList.remove('error', 'success');

            if (!input.value.length) {
                input.focus();
                return false;
            }

            var url = container.getAttribute('data-url');
            fetch(url, {
                method: 'post',
                body: 'amount='+value,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            }).then(res=>res.json())
                .then(function (data) {
                        if (data.valid) {
                            container.classList.add('success');
                            input.value = data.value;
                            input_real.value = data.value;

                            input.setAttribute('readonly', 'readonly');

                            input_real.dispatchEvent(new Event('change', {bubbles: true}));
                        } else {
                            container.classList.add('error');
                        }
                    }
                );
        }
    });

    document.body.addEventListener('change', function(event){
        if (event.target.closest('[data-toggle="cart-summary-spend"]')) {
            var target = event.target.closest('[data-toggle="cart-summary-spend"]');

            if (target.checked) {
                new bootstrap.Collapse('.cart-summary-spend-wrapper', {
                    show: true
                })
            } else {
                new bootstrap.Collapse('.cart-summary-spend-wrapper', {
                    hide: true
                })
            }
        }
    });

    document.body.addEventListener('change', function(event){
        if (event.target.closest('[data-toggle="country-selected"]')) {
            var target = event.target.closest('[data-toggle="country-selected"]');
            var form = target.closest('form');

            var url = target.getAttribute('data-country-regions-url');
            var phoneInputSelector = target.getAttribute('data-set-phone-code-target');
            var regionInputSelector = target.getAttribute('data-set-country-regions-target');

            if (regionInputSelector) {
                var regionInput = form.querySelector(regionInputSelector);

                fetch(url, {
                    method: 'post',
                    body: new FormData(form),
                }).then(res => res.json())
                    .then(function (data) {
                        regionInput.querySelectorAll('option').forEach(function(option){
                            if (option.getAttribute('value') !== '') {
                                option.remove();
                            }
                        });

                        regionInput.value = '';

                        for (var i = 0; i< data.length; i++) {
                            regionInput.options.add(new Option(data[i].text,data[i].value))
                        }

                        regionInput.removeAttribute('disabled');

                        if (event.detail && event.detail.filled) {
                            regionInput.value = event.detail.values[regionInput.name];
                        } else {
                            console.log(focus);
                            regionInput.focus();
                        }
                    }
                );
            }

            if (phoneInputSelector && window.intlTelInputGlobals) {
                var phoneInput = form.querySelector(phoneInputSelector);
                if (phoneInput.value.length < 4) {
                    var iti = window.intlTelInputGlobals.getInstance(phoneInput);
                    iti.setCountry(target.value);
                }
            }
        }
    });

    document.body.addEventListener('click', function(event){
        if (event.target.closest('[data-form-set-values]')) {
            var btn = event.target.closest('[data-form-set-values]');
            var values = JSON.parse(btn.getAttribute('data-form-set-values'));
            var form = btn.closest('form');

            for (let key in values) {
                var input = form.querySelector('[name="'+key+'"]');
                if (input) {
                    input.value = values[key];

                    if (input.matches('[data-toggle="country-selected"]')) {
                        input.dispatchEvent(new CustomEvent('change', {
                            bubbles: true,
                            detail: {
                                filled: true,
                                values: values
                            }
                        }));
                    }
                }
            }

            var toggle = form.querySelector('.delivery-addresses-group .toggle');
            if (toggle && toggle.offsetParent !== null) {
                toggle.dispatchEvent(new Event('click'));
            }
        }
    });
})();